export class Redirections {
    id: any;
    clipboard: boolean = !0;
    printer: boolean = !0;
    rememberCollection: boolean = !1;
}
